import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface WebSocketState {
  connected: boolean;
  messages: Record<string, string> | null;
  studentsStatus: Record<string, string> | null;
}

const initialState: WebSocketState = {
  connected: false,
  messages: null,
  studentsStatus: null,
};

const webSocketSlice = createSlice({
  name: "webSocket",
  initialState,
  reducers: {
    setWebSocketConnected(state) {
      state.connected = true;
    },
    setWebSocketDisconnected(state) {
      state.connected = false;
      state.messages = null;
    },
    addWebSocketMessage(state, action: PayloadAction<Record<string, string>>) {
      state.messages = { ...state.messages, ...action.payload };
    },
    setStudentsStatus(state, action: PayloadAction<Record<string, string>>) {
      state.studentsStatus = { ...state.studentsStatus, ...action.payload };
    },
    clearWebSocketMessages(state) {
      state.messages = null;
    },
  },
});

export const {
  setWebSocketConnected,
  setWebSocketDisconnected,
  addWebSocketMessage,
  clearWebSocketMessages,
  setStudentsStatus,
} = webSocketSlice.actions;

export default webSocketSlice.reducer;
